import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomerComplianceDocument } from '@texas/api/endpoints/customersApi';
import { DataTableContainer } from '@texas/components/shared/dataTable/DataTableContainer';
import { ServerError } from '@texas/types';
import { customerComplianceDocumentColumns } from './columns';

interface Props {
  customerArchived: boolean;
  customerId: number;
  documents: CustomerComplianceDocument[];
  error: ServerError | null;
  onRemove: (document: CustomerComplianceDocument) => void;
}

export function CustomerComplianceDocumentsTable({
  customerArchived,
  customerId,
  documents,
  error,
  onRemove,
}: Props) {
  const { t } = useTranslation();
  const columns = useMemo(
    () =>
      customerComplianceDocumentColumns({
        customerArchived,
        customerId,
        t,
        onRemove,
      }),
    [customerArchived, customerId, onRemove, t],
  );

  return (
    <DataTableContainer
      error={error}
      showColumnToggle={false}
      datatable={{
        columns,
        data: documents,
        variant: 'entityDirectoryCompact',
        rowProps: {
          getRowId: (document) =>
            document.complianceDocumentDefinitionId.toString(),
        },
      }}
    />
  );
}
